import { render, staticRenderFns } from "./FilterSidebarColorsItem.vue?vue&type=template&id=b0f34c3e&scoped=true"
import script from "./FilterSidebarColorsItem.vue?vue&type=script&lang=js"
export * from "./FilterSidebarColorsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f34c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0f34c3e')) {
      api.createRecord('b0f34c3e', component.options)
    } else {
      api.reload('b0f34c3e', component.options)
    }
    module.hot.accept("./FilterSidebarColorsItem.vue?vue&type=template&id=b0f34c3e&scoped=true", function () {
      api.rerender('b0f34c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarColorsItem.vue"
export default component.exports